import { mergeFiles } from 'client/utils/merge-files'
import {
  ADD_FILE,
  ADD_FILES,
  AddFile,
  AddFiles,
  FETCH_COMMON_FILES,
  FETCH_PAGE_FILES,
  FETCH_SEARCH_USER_FILES,
  FETCH_USER_FILES,
  FetchPageFiles,
  FetchSearchUserFiles,
  FetchUserFiles,
  FileActionTypes,
  REMOVE_FILE,
  RemoveFile,
} from './filesActionTypes'

export const fileType = {
  font: 'font',
  image: 'image',
  audio: 'audio',
  video: 'video',
} as const

export type FileType = (typeof fileType)[keyof typeof fileType]

export interface DataFile {
  id: number
  path: string
  filename: string
  name: string
  thumbnail: string
  type: FileType
  filenameWithoutHash: string
}

export type Files = Record<number, DataFile>

export interface FilesState {
  pageFiles: Files
  userFilesSearchValue: string
  userFiles: Files
  isAllFilesFetched: boolean
}

const defaultState: FilesState = {
  pageFiles: {},
  userFilesSearchValue: '',
  userFiles: {},
  isAllFilesFetched: false,
}

export default function (
  state: FilesState = defaultState,
  action: FileActionTypes,
) {
  const { type } = action

  switch (type) {
    case FETCH_PAGE_FILES:
      return {
        ...state,
        pageFiles: {
          ...state.pageFiles,
          ...(action as FetchPageFiles).payload,
        },
      }
    case FETCH_USER_FILES: {
      const files = (action as FetchUserFiles).payload
      return state.userFilesSearchValue
        ? {
            ...state,
            userFilesSearchValue: '',
            userFiles: files,
          }
        : {
            ...state,
            userFiles: {
              ...state.userFiles,
              ...files,
            },
          }
    }
    case FETCH_SEARCH_USER_FILES: {
      const { files, searchValue } = (action as FetchSearchUserFiles).payload
      return {
        ...state,
        userFilesSearchValue: searchValue,
        userFiles:
          state.userFilesSearchValue === searchValue
            ? { ...state.userFiles, ...files }
            : files,
      }
    }
    case FETCH_COMMON_FILES:
      return {
        ...state,
        userFiles: {
          ...mergeFiles(state.userFiles, action.payload),
        },
      }
    case ADD_FILE:
      return {
        ...state,
        userFiles: {
          ...state.userFiles,
          ...(action as AddFile).payload,
        },
      }
    case ADD_FILES:
      return {
        ...state,
        userFiles: {
          ...state.userFiles,
          ...(action as AddFiles).payload,
        },
      }
    case REMOVE_FILE:
      return {
        ...state,
        userFiles: removeFile(state.userFiles, (action as RemoveFile).payload),
      }
    default:
      return state
  }
}

function removeFile(files: Files, removableFileId: number) {
  return Object.values(files)
    .filter(file => file.id !== removableFileId)
    .reduce((acc, file) => ({ ...acc, [file.id]: file }), {})
}
